import axios from "axios";
import { useEffect, useState } from "react";
import _ from 'lodash';
import DefaultLoader from "../../../components/loader/DefaultLoader";
import PitcherTable from '../../../components/table/PitcherTable';
import {useCookies} from 'react-cookie';
import TableWrapper from '../../../components/table/TableWrapper';
import dateSetting from "../../../utils/dateSetting";

const ballObj = {
    Slider: '슬라이더',
    Forkball: '포크',
    Splitter: '포크',
    Cutter: '커터',
    Curveball: '커브',
    Sinker: '싱커',
    Fastball: '직구',
    ChangeUp: '체인지업',
    Sweeper: '스위퍼',
    Other: '기타'
}

function TotalFuturesPitcherRecord({profile}) {
    const [cookies] = useCookies(['hiball_token']);
    let [loading, setLoading] = useState(false);
    let [seasonRecord, setSeasonRecord] = useState([]);
    let {playerId, birthdate} = profile;

    useEffect(() => {
        let dateObj = dateSetting();

        let pitcherRecord = axios({
            url : `${process.env.REACT_APP_API_URL}`,
            params: {
                recordType: 'futuresRecordService', recordName: 'futuresPitcherRecord',
                pitcherIds: playerId,
                seasons: [dateObj['season']-2, dateObj['season']-1, dateObj['season']].toString(),
                groupingColumn: 'season',
                gameTypeCode: 4206,
                authToken:JSON.stringify(cookies['hiball_token'])
            }
        });

        let trackmanRecord = axios({
            url : `${process.env.REACT_APP_API_URL}`,
            params: {
                recordType: 'futuresRecordService', recordName: 'futuresPitcherTrackManRecord',
                pitcherIds: playerId,
                seasons: [dateObj['season']-2, dateObj['season']-1, dateObj['season']].toString(),
                gameTypeCode: 4206,
                authToken:JSON.stringify(cookies['hiball_token'])
            }
        });

        let pitcherPitchRecord = axios({
            url : `${process.env.REACT_APP_API_URL}`,
            params: {
                recordType: 'futuresRecordService', recordName: 'futuresPitcherTrackManRecord',
                pitcherIds: playerId,
                seasons: [dateObj['season']-2, dateObj['season']-1, dateObj['season']].toString(),
                gameTypeCode: 4206,
                groupingColumn: 'ballType',
                authToken:JSON.stringify(cookies['hiball_token'])
            }
        });

        Promise.all([pitcherRecord, trackmanRecord, pitcherPitchRecord])
        .then((result) => {
            let trackmanData = _.map(result[1]['data']['result'], (item) => {
                item['hardHitRate'] = item['hardHit'] ? ((item['hardHit'] / item['inplay'])*100).toFixed(1) : '0.0';
                item['barrelRate'] = item['barrel'] ? ((item['barrel'] / item['inplay'])*100).toFixed(1) : '0.0';
                item['solidContactRate'] = item['solidContact'] ? ((item['solidContact'] / item['inplay'])*100).toFixed(1) : '0.0';

                item['lineDriveRate'] = item['lineDrive'] ? ((item['lineDrive'] / item['inplay'])*100).toFixed(1) : '0.0';
                item['popUpRate'] = item['popUp'] ? ((item['popUp'] / item['inplay'])*100).toFixed(1) : '0.0';
                item['flyRate'] = item['flyBall'] ? ((item['flyBall'] / item['inplay'])*100).toFixed(1) : '0.0';
                item['groundBallRate'] = item['groundBall'] ? ((item['groundBall'] / item['inplay'])*100).toFixed(1) : '0.0';

                item['hangRate'] = item['hang'] ? ((item['hang'] / item['inplay'])*100).toFixed(1) : '0.0';
                item['centerRate'] = item['center'] ? ((item['center'] / item['inplay'])*100).toFixed(1) : '0.0';
                item['pushRate'] = item['push'] ? ((item['push'] / item['inplay'])*100).toFixed(1) : '0.0';

                item['poorlyToppedRate'] = item['poorlyTopped'] ? ((item['poorlyTopped'] / item['inplay'])*100).toFixed(1) : '0.0';
                item['poorlyUnderRate'] = item['poorlyUnder'] ? ((item['poorlyUnder'] / item['inplay'])*100).toFixed(1) : '0.0';
                item['lowHitRate'] = item['lowHit'] ? ((item['lowHit'] / item['inplay'])*100).toFixed(1) : '0.0';

                item['bbRate'] = item['so'] ? ((item['bb']/item['tpa'])*100).toFixed(1) : '0.0';
                item['kRate'] = item['so'] ? ((item['so']/item['tpa'])*100).toFixed(1) : '0.0';

                item['gdDivFly'] = item['fo'] !== 0 ? (item['go']/item['fo']).toFixed(2) : '0.0';
                item['hrDivFly'] = item['fo'] !== 0 ? (item['hr']/item['fo']).toFixed(2) : '0.0';

                item['xba'] = (item['xba']*1).toFixed(3);
                return item;
            });

            let trackmanFlatRecord = _.map(result[1]['data']['result'], (item) => {
                item['type'] = item['season']+"_"+item['pitcherId'];
                return item;
            });

            let indexedTrackmanData = _.keyBy(trackmanFlatRecord, (item) => item['season']);

            let totalData = _.map(result[0]['data']['result'], (item, idx) => {
                let season = item['season'];
                let birthdateYear = birthdate && birthdate.split('/');
                let age = (season*1-birthdateYear[0]*1)-1;

                let trackmanSeasonData = indexedTrackmanData[season];
                item['babip'] = trackmanSeasonData ? trackmanSeasonData['babip'] : '';
                item['k9'] = trackmanSeasonData ? trackmanSeasonData['k9'] : '';
                item['bb9'] = trackmanSeasonData ? trackmanSeasonData['bb9'] : '';
                item['hr9'] = trackmanSeasonData ? trackmanSeasonData['hr9'] : '';
                item['type'] = item['season']+"_"+item['pitcherId']+"_"+idx;
                item['age'] = age;
                return item;
            });

            let pitchData = [];

            let seasonBallGroup = _.groupBy(result[2]['data']['result'], (item, idx) => {
                return item['season'];
            });

            _.forEach(result[2]['data']['result'], (item, idx) => {
                let seasonBallData = seasonBallGroup[item['season']];
                let seasonTotalCnt = _.reduce(seasonBallData, (sum, sumData) => {
                    return sum + sumData['totalPitch']*1;
                }, 0);

                item['type'] = item['season']+"_"+item['pitcherId']+"_"+idx;
                item['ballCodeName'] = ballObj[item['taggedPitchType']];
                item['pa'] = item['tpa'];

                if(item['ab']) {
                    item['pitchRate'] = ((item['totalPitch']/seasonTotalCnt)*100).toFixed(1);
                    pitchData.push(item);
                }
            });

            setSeasonRecord({
                totalData, trackmanData, pitchData: pitchData
            });
            setLoading(true);
        })
    }, []);

    if(!loading) {
        return <div style={{height: '300px'}}><DefaultLoader /></div>
    }

    return (
        <>
        <TableWrapper title={'overall'} trackmanYn={true}>
            <PitcherTable data={seasonRecord['totalData']} column={'futuresTotal'}/>
        </TableWrapper>
        <TableWrapper title={'pitchQuality'}>
            <PitcherTable data={seasonRecord['trackmanData']} column={'futuresPitchingQuality'}/>
        </TableWrapper>
        <TableWrapper title={'battedBalls'}>
            <PitcherTable data={seasonRecord['trackmanData']} column={'futuresHittingType'}/>
        </TableWrapper>
        <TableWrapper title={'pitchTypeInfo'}>
            <PitcherTable data={seasonRecord['pitchData']} column={'futuresPitchData'}/>
        </TableWrapper>
        </>
    )
}

export default TotalFuturesPitcherRecord;